import React, { useState } from "react";
import { Col, Row } from "reactstrap";

const DefaultersType = ({ defaultersType, setDefaultersType }) => {
  return (
    <Row>
      <Col xs={6} className="mt-4">
        <Row className="justify-content-end">
          <Col xs={6}>
            <div
              className={`border ${
                defaultersType === "Individual"
                  ? "border-secondary"
                  : "border-muted"
              } rounded rounded py-2 cursor-pointer`}
              onClick={() => {
                setDefaultersType("Individual");
              }}
            >
              <Row className="justify-content-center">
                <Col xs={12} className="text-center">
                  <h1
                    className={` ${
                      defaultersType === "Individual"
                        ? "text-secondary"
                        : "text-muted"
                    }`}
                  >
                    <i class="bx bxs-user"></i>
                  </h1>
                </Col>
                <Col xs={12} className="text-center">
                  <span
                    className={` ${
                      defaultersType === "Individual"
                        ? "text-secondary"
                        : "text-muted"
                    }`}
                  >
                    Individual
                  </span>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Col>
      <Col xs={6} className="mt-4">
        <Row className="justify-content-start">
          <Col xs={6}>
            <div
              className={`border ${
                defaultersType === "Institutional"
                  ? "border-secondary"
                  : "border-muted"
              }  rounded rounded py-2 cursor-pointer`}
              onClick={() => {
                setDefaultersType("Institutional");
              }}
            >
              <Row className="justify-content-center">
                <Col xs={12} className="text-center">
                  <h1
                    className={` ${
                      defaultersType === "Institutional"
                        ? "text-secondary"
                        : "text-muted"
                    }`}
                  >
                    <i class="bx bxs-building"></i>
                  </h1>
                </Col>
                <Col xs={12} className="text-center">
                  <span
                    className={` ${
                      defaultersType === "Institutional"
                        ? "text-secondary"
                        : "text-muted"
                    }`}
                  >
                    Institutional
                  </span>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DefaultersType;
